import BaseFormItem from "../BaseFormItem";
import { descriptorPropTypes } from "lib/common/descriptorcontrols/formhelpers";
import PropTypes from "prop-types";
import React from "react";
import Control from "lib/common/descriptorcontrols/ChoiceField/checkbox";

export class ChoiceFieldcheckbox extends BaseFormItem {

    constructor(...args) {
        super(...args);
        this.onCommitChange = this.onCommitChange.bind(this);
    }

    onCommitChange(d, v) {
        const {activeRecord, descriptor} = this.props;
        const config = descriptor.config;
        const checkedValue = config.checkedValue || true;
        super.onCommitChange(d, v);
        if (v === checkedValue && config.copyOnClickMappings) {
            for (const m of config.copyOnClickMappings) {
                const src = activeRecord.get(m.source);
                if (src) {
                    super.doSetField(activeRecord, m.target, src);
                }
            }
        }
    }

    render() {
        const {activeRecord, descriptor} = this.props;
        return <Control {...this.getPlumbingProps()}
                        value={activeRecord.get(descriptor.key)}
                        enabled={activeRecord.isFieldEnabled(descriptor.key)}
        />;
    }

}

ChoiceFieldcheckbox.propTypes = {
    ...ChoiceFieldcheckbox.propTypes,
    descriptor: PropTypes.shape(descriptorPropTypes({
        copyOnClickMappings: PropTypes.arrayOf(
            PropTypes.shape({
                source: PropTypes.string.isRequired,
                target: PropTypes.string.isRequired,
            })
        ),
        checkedValue: PropTypes.string.isRequired,
        uncheckedValue: PropTypes.string.isRequired,
    })),
};

export default ChoiceFieldcheckbox;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/ChoiceField/checkbox.js